import { LocalesEnum } from 'src/generated/operations';

type Props = {
    countryDomain: string;
    currentLocale: LocalesEnum;
    label: string;
}

export const getProductUrl = (
    { countryDomain, currentLocale, label }: Props,
) => `${countryDomain}/shop/${currentLocale}/p?code=${encodeURIComponent(label)}`;
